import { useState, useEffect } from "react";
import { PiNotebookLight } from "react-icons/pi";
import { FaRegTrashAlt } from "react-icons/fa";

import {
  getClipboardTerms,
  deleteFromClipboard,
} from "../../../../api/universal";

import {
  ToolbarTriggerButton,
  DropdownPanel,
  DropdownEmptyState,
} from "./_shared";

const DropDownNotes = (props) => {
  const [clipboardTerms, setClipboardTerms] = useState([]);

  useEffect(() => {
    if (!props.isDropDownNotesOpen) return;
    getClipboardTerms().then((response) => {
      if (response.data) {
        const terms = response.data.map((term) => ({
          ts: term.date,
          term: term.term,
        }));
        setClipboardTerms(terms);
      }
    });
  }, [props.isDropDownNotesOpen]);

  const copyToClipboard = async (text) => {
    await navigator.clipboard.writeText(text).catch(console.error);
  };

  const removeFromClipboard = (text) => {
    deleteFromClipboard(text);
    setClipboardTerms((prev) => prev.filter((i) => i.term !== text));
  };

  const handleToggleOpen = () => {
    props.setIsDropDownNotesOpen(!props.isDropDownNotesOpen);
    props.setIsAgentSelectorOpen(false);
    props.setIsPromptLoaderOpen(false);
  };

  return (
    <div className="relative">
      <ToolbarTriggerButton
        icon={PiNotebookLight}
        label="Notes"
        onClick={handleToggleOpen}
        active={props.isDropDownNotesOpen}
      />

      <DropdownPanel isOpen={props.isDropDownNotesOpen}>
        <div className="p-2">
          {clipboardTerms.length > 0 ? (
            <ul className="space-y-0.5">
              {clipboardTerms.map((item, index) => (
                <li
                  key={index}
                  className="group flex items-center justify-between rounded-lg px-3 py-2
                             hover:bg-btnHover transition-colors"
                >
                  <button
                    type="button"
                    className="w-full pr-2 text-left text-[13px] font-normal tracking-wide
                               text-mainText truncate cursor-pointer
                               outline-none focus-visible:ring-2 focus-visible:ring-inputFocus/60 rounded"
                    onClick={() => copyToClipboard(item.term)}
                    title={item.term}
                  >
                    {item.term}
                  </button>
                  <button
                    type="button"
                    className="inline-flex items-center justify-center rounded-md p-1.5
                               text-mutedText/60 hover:text-logoutColor hover:bg-logoutColor/10
                               transition-colors cursor-pointer
                               outline-none focus-visible:ring-2 focus-visible:ring-inputFocus/60"
                    onClick={() => removeFromClipboard(item.term)}
                    aria-label="Delete"
                  >
                    <FaRegTrashAlt className="h-3 w-3" />
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <DropdownEmptyState>No saved notes yet.</DropdownEmptyState>
          )}
        </div>
      </DropdownPanel>
    </div>
  );
};

export default DropDownNotes;
